module.exports = __webpack_public_path__ + "images/emoji/trollface.5d3a65a7e8d31becee85.png";